import { http } from '@/http/axios.js'
export function getListAPI(params) {
  return http({
    url: '/admin/goods/stock/log/page',
    method: 'get',
    params
  })
}
